import {
  ProfileCard,
  ProfileCardHeader,
  ProfileLineWrapper,
  ProfileCardDropdown,
  ProfileDropdownStyle,
  ProfileCardDropdownButton,
} from "@/pages/profile/components/atom";
import { ProfileLine } from "@/pages/profile/components/profile-line";
import { ChangeAccountModal } from "@/pages/profile/components/action-modal/change-account-modal";
import {
  CodeType,
  useModalFormStore,
} from "@/pages/profile/store/modal-form-store";
import { ChangePasswordModal } from "@/pages/profile/components/action-modal/change-password-modal";
import { ChangeNameModal } from "@/pages/profile/components/action-modal/change-name-modal";
import { ViewRecordModal } from "@/pages/profile/components/action-modal/view-record-modal";
import { useTranslation } from "react-i18next";
import { useBusinessParam } from "@/pages/profile/hooks/useBusinessParam";
import {
  IUseProfileInfo,
  useProfileInfo,
} from "@/pages/profile/hooks/useProfileInfo";
import { getDomain } from "project-config/utils/domain";
import { message } from "antd";
import { jumpHelper } from "@/pages/profile/helper/jump-helper";
import { useGlobalStore } from "@/store/GlobalStore";
import { PhoneAppealState } from "project-config/constants/user-info";
import { useChangePassword } from "@/pages/profile/hooks/useChangePassword";
import styled from "styled-components";
import { PhoneStatus } from "@/pages/profile/components/phone-status";
import { isEn } from "project-config/utils/env";
import { useChangeName } from "../../hooks/use-change-name";
import { Dropdown } from "@renderbus/ui";
import AccountDownOutlined from "@/assets/icons/profile/account-down-outlined";
import SignOutModal from "../../components/sign-out-modal";
import { useSignOut } from "../../hooks/use-sign-out";
import WarnningIcon from "@/pages/child-customer/icons/warning";
import { Modal as RModal } from "@/components/renderbus-modal";
import { useMemo } from "react";

export function AccountSecurity() {
  const { t } = useTranslation("profile");
  const isForeign = getDomain();
  const businessParam = useBusinessParam();
  const { profileInfo } = useProfileInfo(businessParam);
  const { isCertified, isSubAccount, userInfo, isDomestic, isDingTalk } =
    useGlobalStore();
  const a1 = t("change_cell_phone_number");
  const a2 = t("change_email");
  const a3 = t("change_password");

  const {
    open,
    rules,
    setOpen,
    setOpenEmail,
    openEmail,
    phoneForm,
    emailForm,
    sendCodeDisable,
    countdown,
    sendCode,
    changeConcatInfo,
    clearForm,
    sending,
    confirmLoading,
  } = useModalFormStore();

  const {
    openPasswordModal,
    setOpenPasswordModal,
    changePasswordForm,
    changePasswordLoading,
    submitChangePassword,
    clearChangePasswordForm,
  } = useChangePassword();

  const {
    openNameModal,
    setOpenNameModal,
    changeNameForm,
    changeNameLoading,
    submitChangeName,
    clearChangeNameForm,
    openViewModal,
    setOpenViewModal,
    leftTimes,
    recordData,
  } = useChangeName();
  const {
    openSignOutModal,
    onSignOutCancel,
    onSignOutConfirm,
    onSignOutOpen,
    openTipModal,
    setOpenTipModal,
    tipContent,
  } = useSignOut();
  const isFirstChangeAccount = useMemo(() => leftTimes === 4, [leftTimes]);
  const a0 = useMemo(
    () => [
      t(
        isFirstChangeAccount ? "account_login_setting" : "account_login_modify"
      ),
      t("account_login_modify_record"),
    ],
    [isFirstChangeAccount, t]
  );

  const changePhone = () => {
    if (!isCertified && isDomestic) {
      return message.error(t("certified_first", { ns: "error" }));
    }

    if (!isSubAccount && isDomestic) {
      const phoneState = profileInfo?.companyAppealResp?.state;
      const link =
        typeof phoneState === "number" && phoneState !== PhoneAppealState.Cancel
          ? "/change-phone-number/by-manual-review"
          : "";
      const { userType, authUnionId } = userInfo || {};
      jumpHelper(link, businessParam, userType, authUnionId);
      return;
    }

    setOpen(true);
  };

  const changePassword = () => {
    if (!isSubAccount && !isForeign) {
      const { userType, authUnionId } = userInfo || {};
      jumpHelper(
        "/change-password",
        businessParam,
        userType,
        isCertified ? authUnionId : ""
      );
      return;
    }

    setOpenPasswordModal(true);
  };

  const getExtra = (profileInfo?: IUseProfileInfo) => {
    if (!profileInfo?.companyAppealResp) {
      return;
    }

    if (
      profileInfo.companyAppealResp.take === 1 ||
      profileInfo.companyAppealResp.state === PhoneAppealState.Cancel
    ) {
      return;
    }

    return <PhoneStatus status={profileInfo.companyAppealResp.state} />;
  };
  return (
    <AccountSecurityWrapper>
      <ProfileCardHeader className="account-security">
        {t("account_security")}
        {!isSubAccount && (
          <ProfileCardDropdown>
            <ProfileDropdownStyle />
            <Dropdown
              overlayClassName="account-security-dropdown"
              trigger={["click"]}
              menu={{
                items: [
                  {
                    key: "1",
                    danger: true,
                    label: (
                      <div onClick={onSignOutOpen}>
                        {t("user_sign_out_title")}
                      </div>
                    ),
                  },
                ],
              }}
            >
              <ProfileCardDropdownButton onClick={(e) => e.preventDefault()}>
                <AccountDownOutlined />
              </ProfileCardDropdownButton>
            </Dropdown>
          </ProfileCardDropdown>
        )}
      </ProfileCardHeader>

      <ProfileLineWrapper>
        {!isSubAccount && (
          <ProfileLine
            title={t("account_login")}
            info={userInfo?.userName}
            action={a0}
            disable={leftTimes === 0}
            disableTip={t("user_modify_limit_tip")}
            isDingTalk={isDingTalk}
            noneTip={isDomestic && !isEn() ? t("no_data") : "-"}
            onClick={[
              () => leftTimes && setOpenNameModal(true),
              () => setOpenViewModal(true),
            ]}
          />
        )}
        <ProfileLine
          title={t("mobile_phone_number")}
          info={userInfo?.phone}
          action={a1}
          isDingTalk={isDingTalk}
          noneTip={isDomestic && !isEn() ? t("no_data") : "-"}
          onClick={() => changePhone()}
          extra={getExtra(profileInfo)}
        />

        <ProfileLine
          title={t("email")}
          info={userInfo?.email}
          action={a2}
          isDingTalk={isDingTalk}
          noneTip={isDomestic && !isEn() ? t("no_data") : "-"}
          onClick={() => setOpenEmail(true)}
        />
        {!isDingTalk && (
          <ProfileLine
            title={t("password")}
            info="******"
            action={a3}
            onClick={() => changePassword()}
          />
        )}

        {/* modal */}
        <ChangeAccountModal
          title={t("change_cell_phone_number")}
          open={open}
          form={phoneForm}
          labelSpan={isEn() ? 7 : 6}
          concatLabel={t("new_cell_phone_number")}
          concatPlaceholder={t("please_enter_new_phone")}
          concatRules={rules.phone}
          validateLabel={t("verification_code")}
          codePlaceholder={t("please_enter_the_verification_code")}
          sendCodeText={t("send_verification_code")}
          sending={sending}
          countDown={countdown}
          sendCodeDisable={sendCodeDisable}
          isForeignPhone={!isDomestic}
          extra={
            isDomestic ? (
              <VoiceButton
                onClick={() => {
                  if (sendCodeDisable) return;
                  sendCode(phoneForm, CodeType.Voice);
                }}
                disabled={sendCodeDisable}
              >
                {t("send_voice_verification_code")}
              </VoiceButton>
            ) : undefined
          }
          sendCode={() => sendCode(phoneForm, CodeType.Sms)}
          modalProps={{
            confirmLoading,
            onCancel: () => {
              clearForm(phoneForm);
              setOpen(false);
            },
            onOk: () => {
              changeConcatInfo(phoneForm);
            },
          }}
        />

        <ChangeAccountModal
          title={t("change_email")}
          open={openEmail}
          form={emailForm}
          labelSpan={6}
          concatLabel={t("new_email")}
          concatPlaceholder={t("please_enter_email")}
          concatRules={rules.email}
          validateLabel={t("verification_code")}
          codePlaceholder={t("please_enter_the_verification_code")}
          sendCodeText={t("send_email_verification_code")}
          sending={sending}
          countDown={countdown}
          sendCodeDisable={sendCodeDisable}
          sendCode={() => sendCode(emailForm, CodeType.Email)}
          modalProps={{
            confirmLoading,
            onCancel: () => {
              clearForm(emailForm);
              setOpenEmail(false);
            },
            onOk: () => {
              changeConcatInfo(emailForm, CodeType.Email);
            },
          }}
        />

        <ChangePasswordModal
          modalProps={{
            title: t("change_password"),
            open: openPasswordModal,
            confirmLoading: changePasswordLoading,
            onOk: () => submitChangePassword(),
            onCancel: () => clearChangePasswordForm(),
          }}
          formProps={{
            size: "large",
            labelCol: { span: isEn() ? 7 : 5 },
            labelAlign: "left",
            colon: false,
            form: changePasswordForm,
            requiredMark: false,
          }}
        />
        <ChangeNameModal
          modalProps={{
            title: t("account_login_modify_title"),
            open: openNameModal,
            confirmLoading: changeNameLoading,
            type: isFirstChangeAccount ? undefined : "tip",
            tipContent: isFirstChangeAccount
              ? ""
              : t("account_login_modify_tip", {
                  0: "3",
                  1: leftTimes,
                }),
            width: "600px",
            onOk: () => submitChangeName(),
            onCancel: () => clearChangeNameForm(),
            okButtonProps: {
              disabled: !Boolean(leftTimes),
            },
          }}
          formProps={{
            size: "large",
            colon: false,
            form: changeNameForm,
            layout: "vertical",
          }}
        />
        <ViewRecordModal
          data={recordData}
          modalProps={{
            title: t("account_login_record_title"),
            open: openViewModal,
            width: "600px",
            onOk: () => setOpenViewModal(false),
            onCancel: () => setOpenViewModal(false),
            cancelButtonProps: {
              style: {
                display: "none",
              },
            },
          }}
        />
        <SignOutModal
          open={openSignOutModal}
          onCancel={onSignOutCancel}
          onOk={onSignOutConfirm}
        />
        <RModal
          open={openTipModal}
          title={
            <TitleWrapper>
              <WarnningIcon />
              <Tilte>{t("user_sign_out_modal_title")}</Tilte>
            </TitleWrapper>
          }
          className="unregister-modal"
          children={<div className="warn-text">{tipContent}</div>}
          onCancel={() => setOpenTipModal(false)}
          onOk={() => setOpenTipModal(false)}
        />
      </ProfileLineWrapper>
    </AccountSecurityWrapper>
  );
}

const VoiceButton = styled.div<{ disabled: boolean }>`
  color: ${({ disabled }) =>
    disabled ? "rgba(255, 255, 255, 0.35)" : "var(--main-color)"};
  cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};
`;

const AccountSecurityWrapper = styled(ProfileCard)`
  // min-width: 600px;
`;

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
`;

const Tilte = styled.div`
  margin-left: 9px;
  font-size: 16px;
  color: #d9dfe0;
`;
